module.exports = __webpack_public_path__ + "assets_app/img/pauseknop-dropshadow.6d695da4.svg";